import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploader from "lib/mixins/uploader";
import PreparingCourseware from 'components/PreparingCourseware.vue'; // import func from '../../../vue-temp/vue-editor-bridge';

export default {
  mixins: [uploader],
  props: {
    IsUpload: {
      type: Boolean,
      default: true
    },
    fileLists: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    IsPreview: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PreparingCourseware: PreparingCourseware
  },
  data: function data() {
    var _ref;

    return _ref = {
      docId: "",
      sourceFiles: [],
      materialids: [],
      imgsList: [],
      imgUrl: "",
      indexCount: 0
    }, _defineProperty(_ref, "docId", ''), _defineProperty(_ref, "dialogVisiblePreviewResources", false), _ref;
  },
  created: function created() {// this.files.forEach(ele=>{
    // });
    // this.fileLists
    // that.sourceFiles.push({
    //   title: res.fileName,
    //   url: data,
    //   status: rst.status
    // });
  },
  watch: {
    fileLists: function fileLists(val) {
      var _this = this;

      val.forEach(function (ele) {
        _this.materialids.push(ele.id);
      });
    }
  },
  methods: {
    dialogClose: function dialogClose() {
      this.dialogVisiblePreviewResources = false;
    },
    uploadFile: function uploadFile() {},
    fileLimit: function fileLimit() {
      this.$message.warning("一次最多上传8个文件");
    },
    beforeUpload: function beforeUpload(file) {
      var ext = file.name.split(".").pop();
      return ["jpg", "jpeg", "png", "gif", "doc", "docx", "txt", "xls", "xlsx", "pdf", "PDF", "zip", "rar"].includes(ext) && this.addFile(file);
    },
    onRemoveHandler: function onRemoveHandler(file) {
      var index = this.materialids.indexOf(file.id);
      this.materialids.splice(index, 1);
      this.$emit("done", this.materialids);
    },
    beforeRemove: function beforeRemove(file, fileList) {},
    handlePreview: function handlePreview(file) {
      if (file.id) {
        this.dialogVisiblePreviewResources = true;
        this.docId = file.id;
      } else {
        this.dialogVisiblePreviewResources = true;
        this.docId = file.response.docId;
      }
    },
    onSuccessHandler: function onSuccessHandler(res, file, uploadFiles) {
      var that = this;
      this.$http.post("/api/XOrg/AttestationActivity/getScreenCourseWareInfo", {
        courseWareId: res.docId
      }).then(function (rst) {
        var data = []; // 判断是否是单张图片

        if (rst.category != "jpg" && rst.category != "jpeg" && rst.category != "png" && rst.category != "gif") {
          var imgs = [];
          var statusUrl = rst.urls.preview_oss_gen; // 拼接图片的地址

          for (var i = 0; i < rst.args_page_count; i++) {
            data.push(statusUrl + (i + 1) + ".png");
          }
        } else {
          data = [res.docPath];
        }

        that.sourceFiles.push({
          title: res.fileName,
          url: data,
          status: rst.status
        });
      });
      this.IsShowUpload = false; // 执行mixins里的onSuccess, 继续下一个文件

      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }

      if (res.code > 0) {
        file.url = res.docPath;
      }

      this.materialids.push(res.docId);
      this.$emit("done", this.materialids);
    }
  }
};